const l = "_table_10bim_1", t = "_tableHead_10bim_5", e = "_cell_10bim_8", _ = "_row_10bim_11", a = "_alignRight_10bim_20", b = "_columnLabel_10bim_23", o = {
  table: l,
  tableHead: t,
  cell: e,
  row: _,
  alignRight: a,
  columnLabel: b
};
export {
  a as alignRight,
  e as cell,
  b as columnLabel,
  o as default,
  _ as row,
  l as table,
  t as tableHead
};
